import { Component } from '@angular/core';
import { NgxPendoService } from 'ngx-pendo';
import { UserService } from 'web-common/src/app/user/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  title = 'app works!';

  constructor(private userService: UserService, private pendoService: NgxPendoService) {}

  ngOnInit(): void {
    this.userService.fetchUser().subscribe((user: any) => {
      const visitor = {
        id: user.id.replace('user:', ''),
        role: user.profile.role,
        area: user.profile.areaOfFocus,
        interfaceLanguage: user.preferences.language,
        trial: `${user.discountGroup.groupSettings.trial}`
      };
      const account = {
        id: user.discountGroup.id.replace('discount:', ''),
        accountName: user.discountGroup.institutionName
      };

      this.pendoService.initialize(visitor, account);
    }, error => {
      console.error('Cannot fetch user', error);
    });
  }
}
